/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { AbsenceOwner } from '@absences/store/absence-owner';
import { Action } from '@ngrx/store';
import { Absence, AbsenceClass } from '@shared/models';
import { AbsenceWrite } from '@shared/models/absence-write';

export const INIT = '[Absences] Init';
export const LOAD_ABSENCES = '[Absences] Load';
export const LOAD_ABSENCES_FAILURE = '[Absences] Load failure';
export const LOAD_ABSENCES_SUCCESS = '[Absences] Load success';
export const EDIT_ABSENCE = '[Absence] Edit';
export const PERSIST_ABSENCE = '[Absence] Persist';
export const PERSIST_ABSENCE_FAILURE = '[Absence] Persist failure';
export const PERSIST_ABSENCE_SUCCESS = '[Absence] Persist success';
export const DELETE_ABSENCE = '[Absence] Delete';
export const DELETE_ABSENCE_FAILURE = '[Absence] Delete failure';
export const DELETE_ABSENCE_SUCCESS = '[Absence] Delete success';
export const LOAD_ABSENCE_CLASSES = '[Absence] Load classes';
export const LOAD_ABSENCE_CLASSES_FAILURE = '[Absence] Load classes failure';
export const LOAD_ABSENCE_CLASSES_SUCCESS = '[Absence] Load classes success';
export const LOAD_SELECTABLE_ABSENCE_CLASSES = '[Absence] Load selectable classes';
export const LOAD_SELECTABLE_ABSENCE_CLASSES_FAILURE = '[Absence] Load selectable classes failure';
export const LOAD_SELECTABLE_ABSENCE_CLASSES_SUCCESS = '[Absence] Load selectable classes success';

export class Init implements Action {
  readonly type = INIT;
  constructor(public absenceClasses: AbsenceClass[]) { }
}

export class LoadAbsences implements Action {
  readonly type = LOAD_ABSENCES;
  constructor(public owner: AbsenceOwner) { }
}

export class LoadAbsencesFailure implements Action {
  readonly type = LOAD_ABSENCES_FAILURE;
}

export class LoadAbsencesSuccess implements Action {
  readonly type = LOAD_ABSENCES_SUCCESS;
  constructor(public absences: Absence[]) { }
}

export class EditAbsence implements Action {
  readonly type = EDIT_ABSENCE;
  constructor(public absence: Absence) { }
}

export class PersistAbsence implements Action {
  readonly type = PERSIST_ABSENCE;
  constructor(public absence: AbsenceWrite) { }
}

export class PersistAbsenceFailure implements Action {
  readonly type = PERSIST_ABSENCE_FAILURE;
}

export class PersistAbsenceSuccess implements Action {
  readonly type = PERSIST_ABSENCE_SUCCESS;
}

export class DeleteAbsence implements Action {
  readonly type = DELETE_ABSENCE;
  constructor(public absenceId: string) { }
}

export class DeleteAbsenceFailure implements Action {
  readonly type = DELETE_ABSENCE_FAILURE;
}

export class DeleteAbsenceSuccess implements Action {
  readonly type = DELETE_ABSENCE_SUCCESS;
}

export class LoadAbsenceClasses implements Action {
  readonly type = LOAD_ABSENCE_CLASSES;
}

export class LoadAbsenceClassesFailure implements Action {
  readonly type = LOAD_ABSENCE_CLASSES_FAILURE;
}

export class LoadAbsenceClassesSuccess implements Action {
  readonly type = LOAD_ABSENCE_CLASSES_SUCCESS;
  constructor(public absenceClasses: AbsenceClass[]) { }
}

export class LoadSelectableAbsenceClasses implements Action {
  readonly type = LOAD_SELECTABLE_ABSENCE_CLASSES;
  constructor(public target: AbsenceOwner['property']) { }
}

export class LoadSelectableAbsenceClassesFailure implements Action {
  readonly type = LOAD_SELECTABLE_ABSENCE_CLASSES_FAILURE;
}

export class LoadSelectableAbsenceClassesSuccess implements Action {
  readonly type = LOAD_SELECTABLE_ABSENCE_CLASSES_SUCCESS;
  constructor(public absenceClasses: AbsenceClass[]) { }
}

export type AbsencesActions = LoadAbsences | LoadAbsencesFailure | LoadAbsencesSuccess | PersistAbsence | PersistAbsenceSuccess |
  PersistAbsenceFailure | DeleteAbsence | DeleteAbsenceFailure | DeleteAbsenceSuccess | EditAbsence | LoadAbsenceClasses |
  LoadAbsenceClassesFailure | LoadAbsenceClassesSuccess | Init | LoadAbsenceClasses | LoadAbsenceClassesSuccess | LoadAbsenceClassesFailure |
  LoadSelectableAbsenceClasses | LoadSelectableAbsenceClassesFailure | LoadSelectableAbsenceClassesSuccess;
